import React from "react";

const Description = ({ data }) => {
  return (
    <div>
      <div className="my-10  text-gray-500">
        <div className=" flex flex-col gap-2 lg:leading-loose lg:text-lg md:mb-10 ">
          <span
            className="  text-justify text-xs lg:text-lg   "
            dangerouslySetInnerHTML={{
              __html: data?.description,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Description;
